export default __webpack_public_path__ + "static/media/checkout-how.cd309224.png";